import { palette } from './palette';
export var color = {
    pureWhite: palette.pureWhite,
    pureBlack: palette.pureBlack,
    theme: {
        typography: {
            ink: palette.neutral9,
            reversed: palette.pureWhite,
            subdued: palette.neutral6,
            subtle: palette.neutral4
        },
        white: palette.neutral1,
        black: palette.neutral9,
        primaryColor: {
            hue: 'blue',
            solid: palette.blue7,
            subdued: palette.blue5,
            subtle: palette.blue3,
            tint: palette.blue2,
            wash: palette.blue1,
            action: {
                primary: palette.blue7,
                secondary: palette.blue5
            }
        },
        supportingColor: {
            hue: 'neutral',
            solid: palette.neutral9,
            subdued: palette.neutral6,
            subtle: palette.neutral4,
            tint: palette.neutral2,
            wash: palette.neutral1,
            action: {
                primary: palette.neutral6,
                secondary: palette.neutral4
            }
        },
        semantic: {
            neutral: {
                primary: {
                    foreground: palette.pureWhite,
                    background: palette.neutral6
                },
                secondary: {
                    foreground: palette.neutral6,
                    background: palette.neutral2
                }
            },
            default: {
                primary: {
                    foreground: palette.pureWhite,
                    background: palette.blue7
                },
                secondary: {
                    foreground: palette.blue7,
                    background: palette.blue2
                }
            },
            additive: {
                primary: {
                    foreground: palette.pureWhite,
                    background: palette.green7
                },
                secondary: {
                    foreground: palette.green7,
                    background: palette.green2
                }
            },
            attention: {
                primary: {
                    foreground: palette.pureWhite,
                    background: palette.yellow7
                },
                secondary: {
                    foreground: palette.yellow8,
                    background: palette.yellow2
                }
            },
            destructive: {
                primary: {
                    foreground: palette.pureWhite,
                    background: palette.red7
                },
                secondary: {
                    foreground: palette.red7,
                    background: palette.red2
                }
            },
            informative: {
                primary: {
                    foreground: palette.pureWhite,
                    background: palette.blue7
                },
                secondary: {
                    foreground: palette.blue7,
                    background: palette.blue2
                }
            }
        },
        state: {
            default: {
                foreground: palette.neutral9,
                background: 'transparent'
            },
            hover: {
                foreground: palette.neutral9,
                background: palette.neutral2
            },
            active: {
                foreground: palette.neutral9,
                background: palette.neutral2
            },
            currentActive: {
                foreground: palette.neutral9,
                background: palette.neutral2
            }
        },
        input: {
            default: {
                foreground: palette.neutral9,
                background: palette.neutral1,
                border: palette.neutral4,
                placeholder: palette.neutral4
            },
            unchecked: {
                foreground: palette.neutral4,
                background: palette.pureWhite
            },
            checked: {
                foreground: palette.blue7,
                background: palette.blue1
            },
            focus: {
                foreground: palette.blue7,
                background: palette.blue1
            },
            error: {
                foreground: palette.red7,
                background: palette.red1
            },
            disabled: {
                foreground: palette.neutral4,
                background: palette.pureWhite
            }
        },
        icon: {
            default: palette.neutral9,
            reversed: palette.pureWhite,
            subdued: palette.neutral6,
            subtle: palette.neutral4
        },
        overlay: {
            light: 'rgba(255, 255, 255, 0.5)',
            dark: 'rgba(0, 0, 0, 0.5)'
        },
        appBackground: palette.neutral1,
        divider: {
            solid: palette.neutral3,
            gradientHorizontal: "linear-gradient(270deg, " + palette.neutral1 + " 0%, " + palette.neutral3 + " 50%, " + palette.neutral1 + " 100%)",
            gradientVertical: "linear-gradient(0deg, " + palette.neutral1 + " 0%, " + palette.neutral3 + " 50%, " + palette.neutral1 + " 100%)"
        },
        primaryNav: {
            background: palette.neutral9,
            state: {
                default: {
                    foreground: palette.pureWhite,
                    background: 'transparent'
                },
                hover: {
                    foreground: palette.pureWhite,
                    background: palette.neutral10
                },
                active: {
                    foreground: palette.neutral2,
                    background: palette.neutral10
                },
                currentActive: {
                    foreground: palette.pureWhite,
                    background: palette.neutral10
                }
            }
        },
        secondaryNav: {
            background: palette.pureWhite,
            state: {
                default: {
                    foreground: palette.neutral6,
                    background: 'transparent'
                },
                hover: {
                    foreground: palette.neutral9,
                    background: 'transparent'
                },
                active: {
                    foreground: palette.neutral9,
                    background: palette.neutral2
                },
                currentActive: {
                    foreground: palette.neutral9,
                    background: palette.neutral2
                }
            }
        }
    }
};
//# sourceMappingURL=color.js.map